module.exports = __webpack_public_path__ + "04_long_black.007ebc46.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/04_long_black.png
// module id = GZpp
// module chunks = 0